<template>
  <div class="animated revealUp">
    <div>
      <div class="mb-5">
        <div class="d-flex justify-content-between align-item-center mb-3">
          <div class="section-title">
            {{ $t("edit") }} {{ $tc("recipe", 2) }}
          </div>
          <div>
            <router-link class="btn-blue" to="recipes"
              >{{ $tc("recipe", 2) }} {{ $tc("list", 2) }}</router-link
            >
          </div>
        </div>

        <div class="white-wrapper">
          <form class="row">
            <div class="col-lg-6 col-xl-4 align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="recipeDetails.recipe_name"
                    name="recipename"
                    id="recipename"
                    v-validate="'required'"
                    placeholder="."
                  />
                  <label>{{ $tc("item", 1) }} {{ $t("name") }}</label>
                </div>
                <!-- <Tooltip :title="$t('recipe_name_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('recipename')">{{
                  errors.first("recipename")
                }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-4  align-self-center mb-2">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    v-model="recipeDetails.recipe_description"
                    name="recipedesc"
                    id="recipedesc"
                    placeholder="."
                  />
                  <label>{{ $tc("recipe", 1) }} {{ $t("description") }}</label>
                </div>
                <!-- <Tooltip :title="$t('recipe_description_tooltip')" /> -->
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('recipedesc')">{{
                  errors.first("recipedesc")
                }}</span>
              </p>
            </div>

            <div
              class="col-lg-6 col-xl-4 align-self-center d-flex mb-2 pb-3 pr-5"
              style="gap: 15px"
            >
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  :disabled="true"
                  v-model="recipeDetails.recipe_is_combo"
                  @change="onChangeStatus($event)"
                  class="j-checkbox"
                  name="recipe_is_combo"
                  id="recipe_is_combo"
                ></b-form-checkbox>
                <label for="recipe_is_combo" class="mb-0 mr-3">{{
                  $t("recipeiscombo")
                }}</label>
              </div>
              <!-- <div class="d-flex align-items-center">
                <b-form-checkbox
                  :disabled="true"
                  v-model="recipeDetails.is_sub_recipe"
                  @change="onChangeSubRecipe($event)"
                  unchecked-value="N"
                  value="Y"
                  class="j-checkbox"
                  name="is_sub_recipe"
                  id="is_sub_recipe"
                ></b-form-checkbox>
                <label for="is_sub_recipe" class="mb-0 mr-3">{{
                  $t("subrecipe")
                }}</label>
              </div> -->

              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="recipeDetails.recipe_is_active"
                  class="j-checkbox"
                  name="recipe_is_active"
                  id="recipe_is_active"
                ></b-form-checkbox>
                <label for="recipe_is_active" class="mb-0 mr-3">{{
                  $t("active")
                }}</label>
              </div>
            </div>

            <div
              v-if="recipeDetails.recipe_is_combo"
              class="col-lg-6 col-xl-3 align-self-center mb-4"
            >
              <multiselect
                v-model="recipes"
                track-by="recipe_name"
                label="recipe_name"
                :options="ms_recipes"
                @select="onSelectRecipe"
                @remove="onRemoveRecipe"
                :multiple="true"
              ></multiselect>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-lg-12 col-xl-12 align-self-center">
              <div class="recipe-box-container">
                <div class="d-flex align-items-end justify-content-between">
                  <div class="recipeItemHead mb-3">
                    {{ "Recipe Items" }}
                  </div>
                  <div
                    v-if="
                      !recipeDetails.recipe_is_combo &&
                        recipeDetails.is_sub_recipe == 'N'
                    "
                    class="d-flex justify-content-end align-self-center mb-2 width40p"
                  >
                    <div class="dropdown-curve-container">
                      <label
                        :class="SelectedSubRecipes.length > 0 ? 'shift-up' : ''"
                        >{{ "Add Sub Recipe" }}</label
                      >
                      <multiselect
                        v-model="SelectedSubRecipes"
                        track-by="recipe_name"
                        label="recipe_name"
                        :options="ms_sub_recipes"
                        @select="onSelectSubRecipe"
                        @remove="onRemoveSubRecipe"
                        :multiple="true"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-lg-12 col-xl-12 align-self-center mb-2"
                    v-for="(itemArr, arrIndex) in recipeItems"
                    :key="arrIndex"
                  >
                    <div class="recipe-box">
                      <div
                        class="sub_recipe_name"
                        v-if="
                          itemArr.length > 0 &&
                            itemArr[0].hasOwnProperty('parent_sub_recipe_id') &&
                            itemArr[0].parent_sub_recipe_id
                        "
                      >
                        {{ getSubRecipeName(itemArr[0].parent_sub_recipe_id) }}
                        &nbsp;<span class="text-truncate fs-12 text-secondary"
                          >Sub-recipe</span
                        >
                      </div>
                      <div class="row">
                        <div class="col-md-11">
                          <div
                            class="row"
                            v-for="(item, index) in itemArr"
                            :key="index"
                          >
                            <!-- IMAGE DIMENSION -->
                            <div class="col-md-6 mb-1">
                              <div class="dropdown-curve-container">
                                <label
                                  :class="
                                    item.raw_material_name.length > 0
                                      ? 'shift-up'
                                      : ''
                                  "
                                  >{{ $t("select") }}
                                  {{ $tc("rawmaterials", 1) }}</label
                                >
                                <b-dropdown
                                  :disabled="item.disabled"
                                  :text="item.raw_material_name"
                                  variant="dropdown-curve"
                                  class="w-100"
                                >
                                  <div class="px-2 pb-2">
                                    <input
                                      required
                                      autofocus
                                      type="search"
                                      placeholder="Search Raw Material"
                                      class="form-control form-control-sm"
                                      v-on:keyup="onSearchRawMaterial()"
                                      v-on:keydown="onSearchRawMaterial()"
                                      v-on:search="onSearchRawMaterial()"
                                      v-model="searchRawMaterial"
                                    />
                                  </div>
                                  <b-dropdown-item
                                    v-for="(rawMaterial,
                                    rawMaterialKey) in rawMaterials"
                                    :key="rawMaterialKey"
                                    v-on:click="
                                      onSelectHandler(
                                        rawMaterial,
                                        'rawMaterial',
                                        arrIndex,
                                        index
                                      )
                                    "
                                    >{{ rawMaterial.rm_name }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="error_message">
                                  <span
                                    v-if="
                                      submitted &&
                                        item.raw_material_name.length == 0
                                    "
                                    >Please Select Raw Material.</span
                                  >
                                </p>
                              </div>
                            </div>

                            <div class="col-md-2 mb-1">
                              <div class="d-flex align-items-center">
                                <div class="input-material">
                                  <input
                                    class="text-right"
                                    :disabled="item.disabled"
                                    :class="{ error: errors.has('qty') }"
                                    style="text-align: right"
                                    type="text"
                                    v-model="item.ri_quantity"
                                    placeholder="."
                                    :name="'qty' + item._uniId + index"
                                    :id="'qty' + item._uniId + index"
                                    v-validate="'required|decimal'"
                                  />
                                  <label>{{ $t("quantity") }}</label>
                                </div>
                                <!-- <Tooltip :title="$t('recipe_quantity_tooltip')" /> -->
                              </div>
                              <p class="error_message">
                                <span
                                  v-if="
                                    submitted &&
                                      errors.has(
                                        `${'qty' + item._uniId + index}`
                                      )
                                  "
                                  >{{
                                    !item.ri_quantity
                                      ? "Qty is Required"
                                      : "Only Numbers and Decimals are allowed"
                                  }}</span
                                >
                              </p>
                            </div>

                            <div class="col-md-2 mb-1">
                              <div class="dropdown-curve-container">
                                <label
                                  :class="
                                    item.uom_unit && item.uom_unit.length > 0
                                      ? 'shift-up'
                                      : ''
                                  "
                                  >{{ $t("uom") }}</label
                                >
                                <b-dropdown
                                  :text="item.uom_unit"
                                  :disabled="item.disabled"
                                  variant="dropdown-curve"
                                  class="w-100"
                                >
                                  <b-dropdown-item
                                    v-for="(uom, uomkey) in item.uom_units"
                                    :key="uomkey"
                                    v-on:click="
                                      onSelectHandler(
                                        uom,
                                        'uom',
                                        arrIndex,
                                        index
                                      )
                                    "
                                    >{{ uom.uom_unit }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="error_message">
                                  <span
                                    v-if="
                                      submitted && item.uom_unit.length == 0
                                    "
                                    >Please Select Unit of Measurement.</span
                                  >
                                </p>
                              </div>
                            </div>

                            <div class="col-md-2">
                              <div class="d-flex align-items-center">
                                <label class="mr-3 mt-2">{{
                                  $t("iscountable")
                                }}</label>
                                <!-- <label class="ios-switch"> -->
                                <b-form-checkbox
                                  type="checkbox"
                                  :disabled="item.disabled"
                                  v-model="item.ri_is_countable"
                                  class="j-checkbox"
                                  checked
                                />
                                <!-- <span class="switch-slider"></span> -->
                                <!-- </label> -->
                              </div>
                              <p class="error_message">
                                <span></span>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-1 d-flex align-items-center mb-3 ml-0 pl-0"
                        >
                          <button
                            v-if="recipeItems.length > 1"
                            @click.prevent.stop="
                              decreaseImageSettingRow(arrIndex, 0)
                            "
                            class="btn-transparent"
                          >
                            <img
                              src="@/assets/img/icons/minus.svg"
                              height="35"
                              width="35"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-12 d-flex align-items-center justify-content-center border-top position-relative my-3"
                  >
                    <button
                      @click.prevent.stop="increaseImageSettingRow($event)"
                      class="btn-transparent add-more-button"
                    >
                      <img
                        src="@/assets/img/icons/plus.svg"
                        height="35"
                        width="35"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 text-center mt-4">
              <button @click.prevent.stop="onFinalSubmit()" class="btn-blue">
                {{ $t("update") }}
              </button>
              <!-- <button v-on:click="onResetForm()" class="btn-black">{{ $t('reset') }}</button> -->
              <b-button
                class="btn-outline-grey"
                variant="default"
                to="recipes"
                >{{ $t("cancel") }}</b-button
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <b-modal
          ref="alreadyInUseRecipe"
          id="alreadyInUseRecipe"
          title="Cannot Deactivate Recipe"
          hide-footer
          no-fade
          centered
          size="md"
        >
          <p class="mb-3 text-danger">
            This recipe cannot be deactivated as it is currently used in the item(s) mentioned below.
          </p>

          <b-table
            striped
            bordered
            hover
            small
            :items="alreadyInUseRecipes"
            :fields="alreadyInUseRecipesfields"
            responsive
            empty-text="No Items found"
          >
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
          </b-table>

          <div class="text-right mt-3">
            <b-button variant="secondary" @click="$bvModal.hide('alreadyInUseRecipe')">
              Close
            </b-button>
          </div>
        </b-modal>
        <b-modal
              ref="rmDependencyInactive"
              id="rmDependencyInactive"
              title="Cannot Activate Recipe"
              hide-footer
              no-fade
              centered
              size="md"
            >
              <p class="mb-3 text-danger">
                This recipe cannot be activated as some of the rawmaterial(s) are not active.
              </p>

              <b-table
                striped
                bordered
                hover
                small
                :items="rmDependencyInactive"
                :fields="rmDependencyInactivefields"
                responsive
                empty-text="No Items found"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>

              <div class="text-right mt-3">
                <b-button variant="secondary" @click="$bvModal.hide('rmDependencyInactive')">
                  Close
                </b-button>
              </div>
            </b-modal>
  </div>
</template>

<script>
  import PosFnbService from "@/services/PosFnbService.js";
  import MasterService from "@/services/MasterService";
  import { removeDuplicates } from "@/helper/collection";
  import _ from "lodash";
  export default {
    data() {
      return {
        alreadyInUseRecipes: [],
        alreadyInUseRecipesfields: [
          { key: 'index', label: '#' },
          { key: 'item_code', label: 'Code' },
          { key: 'item_name', label: 'F&b Item' }
        ],
        rmDependencyInactive: [],
        rmDependencyInactivefields: [
          { key: 'index', label: '#' },
          { key: 'rm_id', label: 'ID' },
          { key: 'rm_name', label: 'Raw Material' }
        ],
        SelectedSubRecipes: [],
        removedItems: [],
        rawMaterialsCopy: [],
        searchRawMaterial: "",
        submitted: false,
        recipeDetails: {},
        recipeItems: [],
        recipe_id: "",
        fc_list: [],
        rawMaterials: [],
        selectedFoodCategory: "Select Food Category",
        units_of_measurements: [],
        //
        ms_recipes: [],
        ms_sub_recipes: [],
        recipes: [],
      };
    },
    beforeMount() {
      const { recipe_id } = this.$route.query;
      if (recipe_id) {
        this.recipe_id = recipe_id;
        this.getRecipeDetails(recipe_id);
      } else {
        this.$router.go(-1);
      }
    },
    mounted() {
      // this.getfcList();
      this.getRawMaterialsList();
      // this.getunitofmeasurements();
      this.getRecipesList();
    },
    methods: {
      getSubRecipeName(Id) {
        let recipeArr = this.ms_sub_recipes.filter((x) => x.recipe_id == Id);
        let text = ``;
        if (recipeArr.length > 0) {
          text = recipeArr[0].recipe_name;
        }
        return text;
      },
      onSearchRawMaterial: function() {
        if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
          this.rawMaterials = this.rawMaterialsCopy.filter((x) => {
            if (
              x.rm_name
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.rawMaterials = this.rawMaterialsCopy;
        }
      },
      getRecipeDetails: function(recipe_id) {
        this.recipeItems = [];
        let parent_sub_recipeId_array = [];
        PosFnbService.GetRecipe({ recipe_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.recipeDetails = data.Records[0];
              // this.selectedFoodCategory = data.Records[0].fc_category;
              this.recipeDetails.recipe_is_active =
                this.recipeDetails.recipe_is_active == "Y" ? true : false;
              this.recipeDetails.recipe_is_combo =
                this.recipeDetails.recipe_is_combo == "Y" ? true : false;
              let tempArr = [];
              data.Records.map((x, index) => {
                if (x.rm_id && String(x.rm_id).length > 0) {
                  tempArr.push({
                    ri_id: x.ri_id,
                    disabled: x.parent_sub_recipe_id ? true : false,
                    _uniId: new Date().valueOf(),
                    subrecipe_name: "",
                    parent_sub_recipe_id: x.parent_sub_recipe_id || null,
                    raw_material_id: x.rm_id,
                    ri_quantity: x.ri_quantity,
                    uom_id: x.uom_id,
                    raw_material_name: x.rm_name,
                    uom_unit: x.uom_unit,
                    ri_is_countable: x.ri_is_countable == "Y" ? true : false,
                    ri_is_active: x.ri_is_active == "Y" ? true : false,
                    uom_units: [],
                  });

                  if (x.parent_sub_recipe_id) {
                    parent_sub_recipeId_array.push(x.parent_sub_recipe_id);
                  }
                }
              });
              let sortedArray = _.groupBy(tempArr, "parent_sub_recipe_id");
              console.log("sortedArray", sortedArray);
              Object.keys(sortedArray).map((key) => {
                if (!isNaN(key)) {
                  this.recipeItems.push(sortedArray[key]);
                } else {
                  sortedArray[key].map((recipeObj) => {
                    console.log("recipeObj", recipeObj);
                    this.recipeItems.push([recipeObj]);
                  });
                }
              });
              this.recipeItems.sort(function(x, y) {
                // true values first
                return x[0].parent_sub_recipe_id
                  ? 0
                  : x[0].parent_sub_recipe_id
                  ? 1
                  : -1;
              });
              console.log("this.recipeItems", this.recipeItems);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            this.getSubRecipesList(parent_sub_recipeId_array);
          });
      },
      getunitofmeasurements: function() {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.units_of_measurements = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onRemoveRecipe: function(selectedOption, id) {
        this.recipeItems = this.recipeItems.filter((x) => {
          return x[0].recipe_id != selectedOption.recipe_id;
        });
      },
      onRemoveSubRecipe: function(selectedOption, id) {
        let checkIndex = this.recipeItems.findIndex((x) =>
          x.some((y) => y.parent_sub_recipe_id == selectedOption.recipe_id)
        );
        if (checkIndex > -1 && this.recipeItems[checkIndex][0].ri_id) {
          this.removedItems.push(this.recipeItems[checkIndex]);
        }
        this.recipeItems.splice(checkIndex, 1);
      },
      onChangeStatus: function(e) {
        if (!this.recipeDetails.recipe_is_combo) {
          this.recipes = [];
        }
      },
      onSelectRecipe: function(selectedOption, id) {
        let payload = {
          recipe_id: selectedOption.recipe_id,
        };
        PosFnbService.GetRecipe(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              let tempArr = [];
              data.Records.map((x) => {
                tempArr.push({
                  disabled: false,
                  _uniId: new Date().valueOf(),
                  subrecipe_name: "",
                  recipe_id: selectedOption.recipe_id,
                  ri_id: x.ri_id,
                  raw_material_id: x.rm_id,
                  ri_quantity: x.ri_quantity,
                  uom_id: x.uom_id,
                  raw_material_name: x.rm_name,
                  uom_unit: x.uom_unit,
                  ri_is_countable: x.ri_is_countable == "Y" ? true : false,
                  ri_is_active: x.ri_is_active == "Y" ? true : false,
                });
              });
              this.recipeItems.push(tempArr);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectSubRecipe(selectedOption, id) {
        let payload = {
          recipe_id: selectedOption.recipe_id,
        };
        PosFnbService.GetRecipe(payload)
          .then((response) => {
            const { data } = response;
            let tempArr = [];
            if (data && data.status && data.Records.length > 0) {
              data.Records.map((x) => {
                tempArr.push({
                  disabled: true,
                  _uniId: new Date().valueOf(),
                  subrecipe_name: x.recipe_name,
                  parent_sub_recipe_id: x.recipe_id,
                  ri_id: null,
                  raw_material_id: x.rm_id,
                  ri_quantity: x.ri_quantity,
                  uom_id: x.uom_id,
                  raw_material_name: x.rm_name,
                  uom_unit: x.uom_unit,
                  ri_is_countable: x.ri_is_countable == "Y" ? true : false,
                  ri_is_active: x.ri_is_active == "Y" ? true : false,
                });
              });
              this.recipeItems.push(tempArr);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterialsList: function() {
        let payload = {
          tableName: "ms_raw_materials",
          rm_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterials = data.Records;
              this.rawMaterialsCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRecipesList: function() {
        let payload = {
          tableName: "ms_recipes",
          recipe_is_active: "Y",
          recipe_is_combo: "N",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ms_recipes = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getSubRecipesList: function(parentSubRrecipeId = []) {
        let payload = {
          tableName: "ms_recipes",
          recipe_is_active: "Y",
          recipe_is_combo: "N",
          is_sub_recipe: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ms_sub_recipes = data.Records;
              if (parentSubRrecipeId.length > 0) {
                let checkFlag = this.SelectedSubRecipes.findIndex((x) =>
                  parentSubRrecipeId.includes(x.recipe_id)
                );
                if (checkFlag == -1) {
                  let subRecipeObj = data.Records.filter((x) =>
                    parentSubRrecipeId.includes(x.recipe_id)
                  );
                  this.SelectedSubRecipes = this.SelectedSubRecipes.concat(
                    subRecipeObj
                  );
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      getfcList: function() {
        let payload = {
          tableName: "ms_food_categories",
          fc_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.fc_list = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      onSelectFoodCategory: function(fc) {
        this.selectedFoodCategory = fc.fc_category;
        this.recipeDetails.category_id = fc.fc_id;
      },
      onSelectHandler: function(item, type, arrIndex, index) {
        if (type == "rawMaterial") {
          this.recipeItems[arrIndex][index].raw_material_id = item.rm_id;
          this.recipeItems[arrIndex][index].raw_material_name = item.rm_name;
          this.recipeItems[arrIndex][index].uom_id = null;
          this.recipeItems[arrIndex][index].uom_unit = "";
          this.getRelatedUom(arrIndex, index, item.rm_id);
          this.searchRawMaterial = "";
          this.onSearchRawMaterial();
        } else if (type == "uom") {
          this.recipeItems[arrIndex][index].uom_id = item.uom_id;
          this.recipeItems[arrIndex][index].uom_unit = item.uom_unit;
        }
      },
      getRelatedUom: function(arrIndex, index, rm_id) {
        PosFnbService.getUomFromRawMaterial({ rm_id })
          .then((response) => {
            // console.log('response :', response);/
            const { data } = response;
            if (data.status) {
              this.recipeItems[arrIndex][index].uom_units = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      increaseImageSettingRow: function() {
        this.recipeItems.push([
          {
            disabled: false,
            _uniId: new Date().valueOf(),
            subrecipe_name: "",
            raw_material_id: "",
            ri_quantity: "",
            uom_id: "",
            raw_material_name: "",
            uom_unit: "",
            ri_is_countable: false,
            ri_is_active: true,
            uom_units: [],
          },
        ]);
      },
      decreaseImageSettingRow: function(arrIndex, index) {
        if (
          this.recipeItems[arrIndex][index].hasOwnProperty(
            "parent_sub_recipe_id"
          )
        ) {
          let tempIndex = this.SelectedSubRecipes.findIndex((x) => {
            return (
              x.recipe_id ==
              this.recipeItems[arrIndex][index].parent_sub_recipe_id
            );
          });
          if (tempIndex > -1) {
            this.SelectedSubRecipes.splice(tempIndex, 1);
          }
        }
        if (this.recipeItems[arrIndex][index].ri_id) {
          this.removedItems.push(this.recipeItems[arrIndex]);
        }
        this.recipeItems.splice(arrIndex, 1);
        console.log("removedItems :>> ", this.removedItems);
      },

      onFinalSubmit: function() {
        this.submitted = true;
        this.$validator.validate().then((valid) => {
          console.log("valid :", valid);
          let finalSubmitArray = [];
          let finalRemoveArray = [];
          this.recipeItems.map((x) => {
            x.map((y) => {
              finalSubmitArray.push(y);
            });
          });
          this.removedItems.map((x) => {
            x.map((y) => {
              finalRemoveArray.push(y);
            });
          });
          console.log("finalSubmitArray", finalSubmitArray);
          console.log("finalRemoveArray", finalRemoveArray);
          if (valid) {
            let payload = {
              ...this.recipeDetails,
              selectedRecipe: finalSubmitArray,
              removedItems: finalRemoveArray,
              recipe_id: this.recipe_id,
            };
            PosFnbService.UpdateRecipe(payload)
              .then((response) => {
                const { data } = response;
                if (data && data.status) {
                  this.$router.push({
                    path: "recipes",
                  });
                } else if(!data.status && data['alreadyInUse'] && data['Records'].length) {
                  this.alreadyInUseRecipes = data['Records']
                  this.$bvModal.show('alreadyInUseRecipe')
                } else if(!data.status && data['dependencyInactive'] && data['Records'].length) {
                  this.rmDependencyInactive = data['Records']
                  this.$bvModal.show('rmDependencyInactive')
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        });
      },
    },
  };
</script>

<style>
  .recipe-box-container {
    /* box-shadow: 0px 0px 7px -5px; */
    border-radius: 10px;
    padding: 12px 20px 20px 20px;
    margin: 5px;
  }

  .recipe-box {
    /* border: 1px solid #202d3633;
  border-radius: 20px;
  padding: 18px 0px 0px 22px; */
    border: 1px solid #202d3617;
    border-radius: 20px;
    padding: 18px 0px 0px 22px;
    background: #d3d3d326;
  }

  .sub_recipe_name {
    margin-left: 5px;
    font-size: 17px;
    font-weight: 600;
    color: var(--blue);
    margin-top: -15px;
    margin-bottom: 20px;
  }

  .recipeItemHead {
    font-size: 18px;
    text-transform: uppercase;
    font-weight: bold;
  }

  .width40p {
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RecipesComponents/editRecipe.vue